import { gql } from '@apollo/client';

export const MUTATION_CREATE_PODCAST_INTERACTION = gql`
  mutation createPodcastInteraction($input: PodcastInteractionInput!) {
    createPodcastInteraction(data: $input) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;

export const MUTATION_CREATE_PODCAST_LISTENING_TIME = gql`
  mutation createPodcastListeningTime($input: PodcastListeningTimeInput!) {
    createPodcastListeningTime(data: $input) {
      data {
        id
        attributes {
          listeningTime
          duration
        }
      }
    }
  }
`;

export const MUTATION_UPDATE_PODCAST_LISTENING_TIME = gql`
  mutation updatePodcastListeningTime($id: ID!, $input: PodcastListeningTimeInput!) {
    updatePodcastListeningTime(id: $id, data: $input) {
      data {
        attributes {
          createdAt
        }
      }
    }
  }
`;
